import { WITHOUT_PORTFOLIO } from '@constants/Text'
import { resolveGroupLabel } from '@modules/consolidator/utils/resolve-group-label/resolve-group-label'
import { BACKEND_NO_PORTFOLIO_KEY } from '@modules/consolidator/utils/adapt-wallet-analysis-response/adapt-wallet-analysis-response'

export const resolveAssetGroupKey = (ativo, groupBy, groupLabelByKey) => {
  if (!ativo || !groupBy) return null
  const rawKey = resolveRawGroupKey(ativo, groupBy, groupLabelByKey)
  return applyDisplayRename(rawKey, groupBy)
}

const resolveRawGroupKey = (ativo, groupBy, groupLabelByKey) => {
  if (groupBy === 'classe') {
    return ativo.classe || ativo.CI || BACKEND_NO_PORTFOLIO_KEY
  }
  if (groupBy === 'subclasse') {
    return (
      ativo.subclasse || ativo.classe || ativo.CI || BACKEND_NO_PORTFOLIO_KEY
    )
  }
  const value = ativo[groupBy]
  if (isMissing(value)) return BACKEND_NO_PORTFOLIO_KEY
  const mapped = resolveGroupLabel(value, groupLabelByKey)
  return mapped || value
}

const applyDisplayRename = (rawKey, groupBy) => {
  if (rawKey === BACKEND_NO_PORTFOLIO_KEY && groupBy === 'nome_portfolio') {
    return WITHOUT_PORTFOLIO
  }
  return rawKey
}

const isMissing = (value) =>
  value === undefined || value === null || value === ''
